export const Const_DomainToAdvisorBaseUrlArray = 'domainToAdvisorBaseUrlArray';
//# sourceMappingURL=types.js.map